function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect } from 'react';
export var usePreloadImages = function usePreloadImages(options) {
  var images = options.images,
      activeIndex = options.activeIndex,
      onImageActivate = options.onImageActivate;

  var _useState = useState(images.map(function (_, index) {
    return {
      width: 0,
      height: 0,
      loaded: false,
      index: index
    };
  })),
      _useState2 = _slicedToArray(_useState, 2),
      imageNodes = _useState2[0],
      setImageNodes = _useState2[1];

  useEffect(function () {
    images.forEach(function (_ref, index) {
      var url = _ref.url;
      var img = new Image();
      img.src = url;

      img.onload = function () {
        setImageNodes(function (nodes) {
          var imageNode = {
            width: img.width,
            height: img.height,
            loaded: true,
            index: index
          };
          return [].concat(_toConsumableArray(nodes.slice(0, index)), [imageNode], _toConsumableArray(nodes.slice(index + 1, nodes.length)));
        });
      };
    });
  }, [images]);
  useEffect(function () {
    var imageNode = imageNodes[activeIndex];

    if (onImageActivate && imageNode.loaded) {
      onImageActivate(imageNode);
    }
  }, [activeIndex, imageNodes]);
  return {
    currentImage: imageNodes[activeIndex],
    imageNodes: imageNodes
  };
};